/* eslint-disable */
import { contactsGreen } from './images'

export const theLightTheme = {
    type: 'light',
    primary: '#0284c7', // Sky 600
    quaternary: '#f8fafc', // Slate 50
    quaternaryLight: '#f1f5f9', // Slate 100
    secondary: '#ffffff',
    tertiary: '#0f172a', // Slate 900
    buttonColor: '#0f172a',
    contactsimg: contactsGreen
}

export const theDarkTheme = {
    type: 'dark',
    primary: '#22d3ee', // Cyan 400
    quaternary: '#0f172a', // Slate 900
    quaternaryLight: '#1e293b', // Slate 800
    secondary: '#1e293b', // Slate 800 (Card bg)
    tertiary: '#f8fafc', // Slate 50 (Text)
    buttonColor: '#38bdf8', // Sky 400
    contactsimg: contactsGreen
}
